import { render, staticRenderFns } from "./site-facing-multi-choice-single.vue?vue&type=template&id=1ab6acac&scoped=true&"
import script from "./site-facing-multi-choice-single.vue?vue&type=script&lang=js&"
export * from "./site-facing-multi-choice-single.vue?vue&type=script&lang=js&"
import style0 from "./site-facing-multi-choice-single.vue?vue&type=style&index=0&id=1ab6acac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab6acac",
  null
  
)

component.options.__file = "site-facing-multi-choice-single.vue"
export default component.exports